"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getVRegionList: ()=>getVRegionList,
    vRegionDowngradeFlag: ()=>vRegionDowngradeFlag
});
const memoize_namespaceObject = require("lodash/memoize");
var memoize_default = /*#__PURE__*/ __webpack_require__.n(memoize_namespaceObject);
const index_js_namespaceObject = require("../domain-id/index.js");
const external_base_js_namespaceObject = require("./base.js");
const product_downgrade_link_js_namespaceObject = require("../utils/product-downgrade-link.js");
const handleDomainID = (source)=>{
    if ('local' === source) return 'sandbox';
    return source;
};
const vRegionDowngradeFlag = Symbol.for('BytecloudCommonLib:VRegion');
const getDowngradeFlag = ()=>Boolean(window[vRegionDowngradeFlag]);
const getVRegionList = memoize_default()(async (param)=>{
    let { apiDomainID, vRegionDomainIDs, platform } = param;
    const domainIDs = vRegionDomainIDs ? vRegionDomainIDs.map(handleDomainID) : [
        handleDomainID((0, index_js_namespaceObject.getCurrentDomainID)())
    ];
    try {
        if (getDowngradeFlag()) {
            const link = (0, product_downgrade_link_js_namespaceObject.generateProductDowngradeLink)({
                domainID: apiDomainID || (0, index_js_namespaceObject.getCurrentDomainID)(),
                configType: 'V2ConfigsVregion'
            });
            if (link) {
                const allRes = await fetch(link).then((res)=>res.json().then((result)=>null == result ? void 0 : result.data));
                const platformRes = null == allRes ? void 0 : allRes[platform];
                if (platformRes) {
                    const result = [];
                    domainIDs.forEach((element)=>{
                        const res = platformRes[element];
                        const list = null == res ? void 0 : res.data;
                        if (Array.isArray(list)) result.push(...list);
                    });
                    return result;
                }
            }
        }
    } catch (error) {
        console.error(error);
    }
    const { data } = await external_base_js_namespaceObject.baseRequest.get('/api/v1/cloud/platform/api/v2/configs/vregion', {
        pluginConfig: {
            domainID: apiDomainID
        },
        params: {
            app_id: platform,
            domain: domainIDs.join(),
            query_type: 'domain'
        }
    });
    return null == data ? void 0 : data.data;
}, (props)=>{
    var _props_vRegionDomainIDs;
    return `${props.apiDomainID}#${props.platform}#${null == (_props_vRegionDomainIDs = props.vRegionDomainIDs) ? void 0 : _props_vRegionDomainIDs.join()}#${getDowngradeFlag()}`;
});
exports.getVRegionList = __webpack_exports__.getVRegionList;
exports.vRegionDowngradeFlag = __webpack_exports__.vRegionDowngradeFlag;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getVRegionList",
    "vRegionDowngradeFlag"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
